import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, ChevronDown } from 'lucide-react'

const C = { ink: '#202523', ink2: '#6D7471', border: '#E1E5E3' }
const FH = "'Plus Jakarta Sans', sans-serif"
const FB = "'Inter', sans-serif"

const FAQS: { q: string; a: string }[] = [
  {
    q: '¿Qué es Párchala?',
    a: 'Una app para descubrir lo que está pasando en Pereira ahora mismo: promociones, eventos y planes que publican los negocios de la ciudad.',
  },
  {
    q: '¿Cómo guardo una actividad para verla después?',
    a: 'Tocá el ícono de guardar (el marcador) en cualquier publicación. La vas a encontrar luego en "Guardados", en el menú lateral.',
  },
  {
    q: '¿Qué significa marcar "Me interesa"?',
    a: 'Es tu forma de decirle al negocio (y a vos mismo) que te llama la atención un plan. Las actividades marcadas quedan en "Actividades de interés", dentro de tu perfil.',
  },
  {
    q: '¿Cómo sigo a un negocio?',
    a: 'Entrá al perfil del negocio (tocando su nombre o su foto en cualquier publicación) y tocá el botón "Seguir". Vas a poder verlo en "Negocios que sigo" desde tu perfil.',
  },
  {
    q: '¿Cómo cambio mi nombre de usuario o mi bio?',
    a: 'Andá a tu perfil y entrá a "Configuración". Ahí podés editar tu nombre de usuario y tu bio en cualquier momento.',
  },
  {
    q: '¿Cómo elimino mi cuenta o descargo mis datos?',
    a: 'Desde tu perfil, entrá a "Privacidad y datos". Ahí podés descargar una copia de tu información o eliminar tu cuenta de forma permanente.',
  },
  {
    q: '¿Cómo reporto un problema o un negocio?',
    a: 'Estamos preparando un canal directo para esto. Muy pronto vas a poder escribirnos desde acá mismo.',
  },
]

export default function HelpCenterPage() {
  const navigate = useNavigate()
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '28px 28px 60px' }}>
      <button
        onClick={() => navigate('/profile')}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: C.ink2,
          fontFamily: FB,
          fontSize: 13.5,
          marginBottom: 18,
          padding: 0,
        }}
      >
        <ArrowLeft size={16} /> Volver al perfil
      </button>

      <div
        style={{
          fontFamily: FH,
          fontWeight: 800,
          fontSize: 24,
          letterSpacing: '-0.01em',
          marginBottom: 22,
        }}
      >
        Centro de ayuda
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {FAQS.map((item, i) => {
          const open = openIndex === i
          return (
            <div
              key={item.q}
              style={{
                background: '#fff',
                border: `1px solid ${C.border}`,
                borderRadius: 14,
                overflow: 'hidden',
              }}
            >
              <button
                onClick={() => setOpenIndex(open ? null : i)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 12,
                  padding: '15px 18px',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontFamily: FH,
                  fontWeight: 700,
                  fontSize: 14.5,
                  color: C.ink,
                }}
              >
                <span>{item.q}</span>
                <ChevronDown
                  size={18}
                  color={C.ink2}
                  style={{
                    flexShrink: 0,
                    transform: open ? 'rotate(180deg)' : 'none',
                    transition: 'transform .15s ease',
                  }}
                />
              </button>
              {open && (
                <div
                  style={{
                    padding: '0 18px 16px',
                    fontSize: 14,
                    color: C.ink2,
                    lineHeight: 1.6,
                  }}
                >
                  {item.a}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
